const pai = {
    id: 'pai-mae-hong-son',
    type: 'photoPost',
    countryId: 'seAsia',
    title: 'Pai and Mae Hong Son, Thailand: Photos',
    month: 'Jan',
    date: '22',
    content: [
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai1.jpg',
            detailText: 'Khao Soi! At our favorite spot in Pai, The Curry Shack (just off the night market street).'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai2.jpg',
            detailText: 'The white buddha at Chedi Phra That Mae Yen, overlooking Pai.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai3.jpg',
            detailText: 'The buddha\'s view.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai4.jpg',
            detailText: 'Mo Paeng waterfall outside Pai.'
        },
       {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai5.jpg','https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai6.jpg'],
            detailText: 'Left, Peter at Pam Bok waterfall. Right, Alice at the Pai Historical Bridge.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai7.jpg',
            detailText: 'The gorgeous Pai Canyon at sunset (this and next 3 photos).'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai8.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai9.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai10.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai11.jpg',
            detailText: 'A bamboo tunnel in Mae Surin Waterfall National Park.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai12.jpg',
            detailText: 'Mae Surin Waterfall National Park.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai13.jpg',
            detailText: 'Mae Surin Waterfall National Park.'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/pai-mae-hong-son/pai14.jpg',
            detailText: 'Mural of ethnic groups in Mae Hong Son province.'
        }
]
}


export default pai


// WEBPACK FOOTER //
// ./src/Posts/Content/pai.js